import React, { ReactNode } from 'react';
import { useReorderableDND } from './useReorderableDND';
import './reorderable.css';

interface ReorderableListProps<T> {
  items: T[];
  onReorder: (newItems: T[]) => void;
  itemKey: (item: T) => string | number;
  renderItem: (item: T, index: number, dragProps: any) => ReactNode;
  className?: string;
  style?: React.CSSProperties;
  showDragHandle?: boolean;
}

export function ReorderableList<T>({ 
  items, 
  onReorder, 
  itemKey, 
  renderItem, 
  className = '',
  showDragHandle = false
}: ReorderableListProps<T>) {
  const { getContainerProps, getItemProps, dragState } = useReorderableDND({
    items,
    onReorder,
    itemKey,
  });

  return (
    <div 
      {...getContainerProps()} 
      className={`reorderable-list ${className}`}
    >
      {items.map((item, index) => (
        <div
          {...getItemProps(item, index)}
          className={`reorderable-item ${dragState.dragOverIndex === index ? 'drag-over' : ''}`}
          key={itemKey(item)}
        >
          {renderItem(item, index, {
            ...getItemProps(item, index),
            showDragHandle
          })}
        </div>
      ))}
    </div>
  );
} 